<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Lista de clientes inadimplentes</h1>
    <div class="d-flex align-items-center gap-3">
      <span class="text-muted">Total de registros: {{ totalElements }}</span>
      <button class="btn btn-outline-secondary" (click)="imprimir()" [disabled]="totalElements === 0">
        <i class="bi bi-printer me-1"></i> Imprimir
      </button>
    </div>
  </div>
  <hr />

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Nome / Razão Social</th>
          <th scope="col">CPF/CNPJ</th>
          <th scope="col">Telefone</th>
          <th scope="col">Valor em Aberto</th>
          <th scope="col" class="text-center">Débitos Vencidos</th>
          <th scope="col">Primeiro Vencimento</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of inadimplentes">
          <td>{{ item.nomeRazaoSocial }}</td>
          @if (item.cpfCnpj && item.cpfCnpj.length === 11) {
            <td>{{ item.cpfCnpj | mask: '000.000.000-00' }}</td>
          } @else {
            <td>{{ item.cpfCnpj | mask: '00.000.000/0000-00' }}</td>
          }
          <td>{{ item.telefone | mask: '(00) 00000-0000' }}</td>
          <td>{{ item.valorEmAberto | currency:'BRL' }}</td>
          <td class="text-center">
            <span class="badge"
              [class.bg-danger]="item.qtdDebitosVencidos >= 3"
              [class.bg-warning]="item.qtdDebitosVencidos === 2"
              [class.bg-secondary]="item.qtdDebitosVencidos === 1">
              {{ item.qtdDebitosVencidos }}
            </span>
          </td>
          <td>{{ formatarData(item.primeiroVencimento) }}</td>
          <td class="text-center">
            <button  type="button" class="btn btn-warning btn-sm me-2"(click)="verVendasCliente(item.idCliente)">Vendas</button>
            <button type="button" class="btn btn-danger btn-sm  me-2" (click)="verParcelasAbertas(item.idVenda)">Parcelas</button>
          
          </td>
        </tr>
        <tr *ngIf="!inadimplentes.length">
          <td colspan="7" class="text-center text-muted py-4">Nenhum inadimplente encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 0">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(0)">Primeira</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 0">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page + 1 }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages - 1)">Última</a>
      </li>
    </ul>
  </nav>
</div>
